import {
    NetsOperation,
    NetsProcessResponseFragment,
    NetsTransactionFragment,
    NetsTransactionPreAuthFragment,
} from "../generated/gql/graphql";
import { Timelapse } from "@mui/icons-material";
import { Button, Paper, Popover, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { formatMoney } from "../views/NetsTransactionsListPage";
import React, { useState } from "react";
import { NetsResponseCode } from "./NetsResponseCode";
import { TimestampText } from "./date_time";

export function TransactionPreAuthButton({
    transaction,
    preAuth,
}: {
    transaction: NetsTransactionFragment;
    preAuth: NetsTransactionPreAuthFragment;
}) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <Button
                onClick={handleClick}
                startIcon={<Timelapse />}
                variant={"outlined"}
                color={"success"}
                size={"small"}
            >
                {formatMoney(preAuth.amountAuthorized)}
            </Button>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
            >
                <TransactionPreAuthCard transaction={transaction} preAuth={preAuth} />
            </Popover>
        </>
    );
}

function TransactionPreAuthCard({
    transaction,
    preAuth,
}: {
    transaction: NetsTransactionFragment;
    preAuth: NetsTransactionPreAuthFragment;
}) {
    return (
        <Paper sx={{ p: 1, maxWidth: 600 }}>
            <Table size="small">
                <TableBody>
                    <TableRow>
                        <TableCell colSpan={2}>
                            <Typography variant="h6" gutterBottom style={{ marginTop: "10px" }}>
                                Reservasjon: opprettet
                            </Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" sx={{ fontWeight: "bold" }}>
                            Transaksjons-Id
                        </TableCell>
                        <TableCell>{preAuth.netsTransactionId}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" sx={{ fontWeight: "bold" }}>
                            Tidspunkt
                        </TableCell>
                        <TableCell>
                            <TimestampText value={preAuth.createdTime} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" sx={{ fontWeight: "bold" }}>
                            Beløp
                        </TableCell>
                        <TableCell>{formatMoney(preAuth.amount)}</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell colSpan={2}>
                            <Typography variant="h6" gutterBottom style={{ marginTop: "20px" }}>
                                {preAuth.authorizedTime
                                    ? preAuth.amountAuthorized
                                        ? "Reservasjon: godkjent"
                                        : "Reservasjon: avslått"
                                    : "Reservasjon: venrter"}
                            </Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" sx={{ fontWeight: "bold" }}>
                            Tidspunkt
                        </TableCell>
                        <TableCell>
                            <TimestampText value={preAuth.authorizedTime} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" sx={{ fontWeight: "bold" }}>
                            Beløp
                        </TableCell>
                        <TableCell>{formatMoney(preAuth.amountAuthorized)}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" sx={{ fontWeight: "bold" }}>
                            Respons
                        </TableCell>
                        <TableCell>
                            <NetsResponseCode
                                operation={NetsOperation.Auth}
                                response={preAuth.authResponse as NetsProcessResponseFragment}
                            />
                        </TableCell>
                    </TableRow>

                    {preAuth.finalizedTime ? (
                        <React.Fragment>
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <Typography variant="h6" gutterBottom style={{ marginTop: "20px" }}>
                                        Betalingstrekk opprettet (fra reservasjon)
                                    </Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" sx={{ fontWeight: "bold" }}>
                                    Tidspunkt
                                </TableCell>
                                <TableCell>
                                    <TimestampText value={preAuth.finalizedTime} />
                                </TableCell>
                            </TableRow>
                        </React.Fragment>
                    ) : null}
                </TableBody>
            </Table>
        </Paper>
    );
}
